// Turbo drives page visits only, the job Turbolinks did on production. turboboost: true forms are jquery_ujs /
// rails-ujs XHRs (config/initializers/turboboost_shim.rb) and other forms submit natively, unless a form opts in
// with data-turbo="true". The application and core_static packs import this right after @hotwired/turbo, so the
// mode is set even when a later import of the pack throws.
import { config } from '@hotwired/turbo'

config.forms.mode = 'optin'
